import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { $mapLoaded } from '../../models/mapModel/index.js';
import { changeLayerVisibility } from '../../utils/mapbox-utils.js';
import {
  $absoluteLayers,
  $isAbsolute,
} from '../../models/absoluteModel/index.js';

function AbsolutePointsPreset({ points, name, color }) {
  const mapLoaded = useUnit($mapLoaded);
  const absoluteLayers = useUnit($absoluteLayers);
  const isAbsolute = useUnit($isAbsolute);

  const createLayer = (update) => {
    const pointsData = {
      type: 'FeatureCollection',
      features: points,
    };

    if (update) {
      window.map.getSource(`absolute_${name}_source`).setData(pointsData);
    } else {
      if (!window.map.getSource(`absolute_${name}_source`)) {
        window.map.addSource(`absolute_${name}_source`, {
          type: 'geojson',
          data: pointsData,
        });
      }
      if (!window.map.getLayer(`absolute_${name}_layer`)) {
        window.map.addLayer({
          id: `absolute_${name}_layer`,
          type: 'symbol',
          source: `absolute_${name}_source`,
          layout: {
            'icon-image': name,
            'icon-size': 2,
            'icon-allow-overlap': true,
          },
        });
      }
      changeLayerVisibility(`absolute_${name}_layer`, false);
    }
  };

  useEffect(() => {
    if (mapLoaded && points) {
      if (window.map.getLayer(`absolute_${name}_layer`)) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, points]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer(`absolute_${name}_layer`)) {
      if (isAbsolute) {
        if (absoluteLayers.find((item) => item.name === name)) {
          changeLayerVisibility(`absolute_${name}_layer`, true);
          window.map.moveLayer(`absolute_${name}_layer`);
        } else {
          changeLayerVisibility(`absolute_${name}_layer`, false);
        }
      } else {
        changeLayerVisibility(`absolute_${name}_layer`, false);
      }
    }
  }, [mapLoaded, absoluteLayers, isAbsolute]);

  return null;
}

export default AbsolutePointsPreset;
